import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, InputAdornment, FormControl, RadioGroup, FormControlLabel, Radio, TableSortLabel, DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog } from "@mui/material";
import TokenError from '../tokenError';
import { useEffect, useRef, useState } from "react";
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import config from '../../config/config.js';
import AddIcon from "@mui/icons-material/Add";
import dayjs from 'dayjs';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Label } from "flowbite-react";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer.js";
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import importArrowIcon from '../../assets/images/importArrow.svg';
import { CSVLink } from "react-csv";

var constants = require('../../constant');

const TmsBooking = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [rows, setRows] = useState([]);

    const bookingStatusMap = {
        "1": "Unassigned",
        "2": "Assigned",
        "3": "Ongoing",
        "4": "Delivered",
        "5": "Cancelled",
        "6": "Foul Trips",
        "7": "Heading to Pickup Container",
        "8": "Arrived at Pickup Container",
        "9": "Departed from Pickup Container",
        "10": "Arrived at Trip Pickup",
        "11": "Trip Started"


    //     REASSIGNED: 1,
    // ASSIGNED: 2,
    // ONGOING: 3,
    // DELIVERED: 4,
    // CANCELLED: 5,
    // FOUL: 6,
    // START_TO_PICKUP_CONTAINER: 7,
    // ARRIVED_AT_CONTAINER_PICKUP: 8,
    // DEPART_FROM_CONTAINER_PICKUP: 9,
    // ARRIVED_AT_TRIP_PICKUP: 10,
    // START_TRIP: 11
    };
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [prePickupEnabled, setPrePickupEnabled] = useState(false);
    const [containerPickupAddress, setContainerPickupAddress] = useState('');
    const [containerPickupDate, setContainerPickupDate] = useState(dayjs());

    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('booking_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [bookingData, setBookingData] = useState([]);
    const [allData, setAllData] = useState([]);
    const fileInputRef = useRef(null);
    const [showTemplateButton, setShowTemplateButton] = useState(false);

    const [bookingId, setBookingId] = useState('');
    const [clientId, setClientId] = useState('');
    const [movementType, setMovementType] = useState('');
    const [containerSize, setContainerSize] = useState('');
    const [containerType, setContainerType] = useState('');
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [pickupDate, setPickupDate] = useState(dayjs());
    const [dropDate, setDropDate] = useState(dayjs());
    const [bookingStatus, setBookingStatus] = useState('');
    const [startDateFilter, setStartDateFilter] = useState(dayjs().subtract(7, 'day'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs());
    const [bookingStatusFilter, setBookingStatusFilter] = useState('-1');
    const [locationData, setLocationData] = useState([]);
    const [bookingConstants, setBookingConstants] = useState([]);
    const [rejectValue, setRejectValue] = useState('');
    const [formErrors, setFormErrors] = useState({
        clientId: false,
        movementType: false,
        containerSize: false,
        containerType: false,
        pickupAddress: false,
        dropAddress: false,
        pickupDate: false,
        dropDate: false,
        containerPickupAddress: false,
        containerPickupDate: false,
        distance: false,
        containerDetails: [] // Will store validation for each container's fields
    });
    const [distance, setDistance] = useState('');
    
    const [containers, setContainers] = useState([
        { container_no: '', container_condition: '', container_size_value: '' }
    ]);
    
    const [clientData, setClientData] = useState([]);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false);
        setShowTemplateButton(false);
    }
    
    // Format data for CSV export
    const formatDataForCSV = (data) => {
        return data.map(item => ({
            'Booking ID': item.booking_id || '',
            'Client': item.tms_client_name || '',
            'Type of Movement': item.container_movement_type || '',
            'Container Type': item.container_type || '',
            'Container Size': item.container_size || '',
            'Pickup Address': item.pickup_address || '',
            'Drop Address': item.drop_address || '',
            'Pickup Date': item.pickup_time ? new Date(item.pickup_time).toLocaleString() : '',
            'Drop Date': item.drop_time ? new Date(item.drop_time).toLocaleString() : '',
            'Status': bookingStatusMap[item.booking_status] || ''
        }));
    };

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const fetchBookingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                // status: bookingStatusFilter,
                timestamp: timestamp
            };

            if(bookingStatusFilter!='-1'){
                body.status = bookingStatusFilter;
            }
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by booking_id
                const sortedData = [...response.data].sort((a, b) => {
                    // Convert to numbers to ensure proper numeric sorting
                    const bookingIdA = parseInt(a.booking_id);
                    const bookingIdB = parseInt(b.booking_id);
                    return bookingIdB - bookingIdA; // Descending order
                });
                
                setRows(sortedData);
                
                // Prepare data for CSV export
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchBookingsData();
        fetchTmsLocation();
        fetchBookingSettingsData();
        fetchClientData();
    }, [cityFilter, startDateFilter, endDateFilter, bookingStatusFilter]);

    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
    }

    const handleOpenAddbooking = () => {
        setOpenAddModal(true);
        setBookingId('');
        setClientId('');
        setMovementType('');
        setContainerSize('');
        setDistance('');
        setContainerType('');
        setPrePickupEnabled(false);
        setPickupAddress('');
        setRejectValue('');
        setDropAddress('');
        setPickupDate(dayjs());
        setDropDate(dayjs());
        setBookingStatus('');
        setContainerPickupAddress('');
        setContainerPickupDate(dayjs());
        setContainers([
            { container_no: '', container_condition: '', container_size_value: '' }
        ]);
        // Reset form validation errors
        setFormErrors({
            clientId: false,
            movementType: false,
            containerSize: false,
            containerType: false,
            pickupAddress: false,
            dropAddress: false,
            pickupDate: false,
            dropDate: false,
            containerPickupAddress: false,
            containerPickupDate: false,
            distance: false,
            containerDetails: [{ container_no: false, container_condition: false, container_size_value: false }]
        });
    }

    const handleOpenEditBooking = (row) => {
        setOpenEditModal(true);
        setBookingId(row.booking_id);
        setClientId(row.tms_client_id);
        setMovementType(row.container_movement_type);
        setContainerSize(row.container_size);
        setContainerType(row.container_type);
        setPickupAddress(row.pickup_location_id);
        setDropAddress(row.drop_location_id);
        setPickupDate(dayjs(row.pickup_time));
        setDropDate(dayjs(row.drop_time));
        setBookingStatus(row.booking_status);
        // Reset form validation errors since we're populating with valid data
        setFormErrors({
            clientId: false,
            movementType: false,
            containerSize: false,
            containerType: false,
            pickupAddress: false,
            dropAddress: false,
            pickupDate: false,
            dropDate: false,
            containerPickupAddress: false,
            containerPickupDate: false,
            distance: false,
            containerDetails: row.container_details && row.container_details.length > 0
                ? row.container_details.map(() => ({ 
                    container_no: false, 
                    container_condition: false, 
                    container_size_value: false 
                }))
                : [{ container_no: false, container_condition: false, container_size_value: false }]
        });
        setContainerPickupAddress(row.pre_pickup_container_pickup_id);
        setContainerPickupDate(dayjs(row.container_pickup_time));
        setPrePickupEnabled(row.is_pre_pickup_container);
        setRejectValue(row.booking_type);
        setDistance(row.distance);
        
        // Handle container details properly
        if (row.container_details) {
            // If container_details is a string (JSON), parse it
            if (typeof row.container_details === 'string') {
                try {
                    const parsedContainers = JSON.parse(row.container_details);
                    if (Array.isArray(parsedContainers)) {
                        setContainers(parsedContainers);
                    } else if (typeof parsedContainers === 'object') {
                        // If it's an object with container_1, container_2 keys
                        const containerArray = Object.values(parsedContainers);
                        setContainers(containerArray.length > 0 ? containerArray : [{ container_no: '', container_condition: '', container_size_value: '' }]);
                    }
                } catch (e) {
                    console.error('Error parsing container details:', e);
                    setContainers([{ container_no: '', container_condition: '', container_size_value: '' }]);
                }
            } 
            // If it's already an object
            else if (typeof row.container_details === 'object') {
                if (Array.isArray(row.container_details)) {
                    setContainers(row.container_details);
                } else {
                    // Convert object format (container_1, container_2) to array
                    const containerArray = Object.values(row.container_details);
                    setContainers(containerArray.length > 0 ? containerArray : [{ container_no: '', container_condition: '', container_size_value: '' }]);
                }
            }
        } else {
            // Fallback to empty container if no container details
            setContainers([{ container_no: '', container_condition: '', container_size_value: '' }]);
        }
    }

    const handleAddContainer = () => {
        setContainers([...containers, { container_no: '', container_condition: '', container_size_value: '' }]);
    };

    const handleRemoveContainer = (index) => {
        const updatedContainers = [...containers];
        updatedContainers.splice(index, 1);
        setContainers(updatedContainers);
    };

    const handleContainerChange = (index, field, value) => {
        const updatedContainers = [...containers];
        updatedContainers[index][field] = value;
        setContainers(updatedContainers);
    };

    const fetchBookingSettingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_tms_booking_settings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag == 200){
                const data = response.data[0]; // ✅ Fix here
                console.log('data', data.booking_fields.type_of_movement);
              
                setBookingConstants(data);
                // setTypeOfMovement(data.booking_fields.type_of_movement || []);
                // setContainerType(data.booking_fields.container_type || []);
                // setContainerSize(data.booking_fields.container_size || []);
                // setTruckAvailabilityStatus(data.truck_head_fields.truck_availabilty_status || []);
                // setInspectionItems(data.inspection_fields.inspection_item || []);
              }
              
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }


    const fetchClientData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_clients';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setClientData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const handleSubmit = async() =>{
        // Validate required fields
        const errors = {
            clientId: !clientId,
            movementType: !movementType,
            containerSize: !containerSize,
            containerType: !containerType,
            pickupAddress: !pickupAddress,
            dropAddress: !dropAddress,
            pickupDate: !pickupDate,
            dropDate: !dropDate,
            distance: !distance.trim()
        };
        
        // Validate each container's details
        const containerErrors = containers.map(container => ({
            container_no: !container.container_no.trim(),
            container_condition: !container.container_condition.trim(),
            container_size_value: !container.container_size_value
        }));
        errors.containerDetails = containerErrors;
        
        // Additional validation for pre-pickup fields if enabled
        if (prePickupEnabled) {
            errors.containerPickupAddress = !containerPickupAddress;
            errors.containerPickupDate = !containerPickupDate;
        }
        
        setFormErrors(errors);
        
        // Check if any basic fields have errors
        const hasBasicErrors = Object.entries(errors).some(([key, value]) => {
            return key !== 'containerDetails' && value === true;
        });
        
        // Check if any container fields have errors
        const hasContainerErrors = errors.containerDetails.some(container => 
            Object.values(container).some(error => error)
        );
        
        // If any validation errors exist, prevent form submission
        if (hasBasicErrors || hasContainerErrors) {
            setMessage('Please fill in all required fields');
            showSnackbar(true);
            return; // Prevent form submission
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            tms_client_id: clientId,
            container_movement_type: movementType,
            container_size: containerSize,
            container_type: containerType,
            pickup_location_id: pickupAddress,
            drop_location_id: dropAddress,
            pickup_time: pickupDate ? pickupDate : null,
            drop_time: dropDate ? dropDate : null,
            booking_status: bookingStatus ? bookingStatus : "1",
            booking_type: rejectValue,
            container_details: containers,
            is_pre_pickup_container: (prePickupEnabled===1||prePickupEnabled==true) ? 1 : 0,
            distance: distance
        };
        if(openEditModal && bookingId!=''){
            payload.booking_id = bookingId;
        }
        if(prePickupEnabled){
            // Validate that container pickup date is less than pickup date
            if (containerPickupDate && pickupDate) {
                const containerPickupDateTime = new Date(containerPickupDate);
                const pickupDateTime = new Date(pickupDate);

                if (containerPickupDateTime >= pickupDateTime) {
                    setMessage('Container Pickup Date & Time should be less than the Pickup Date & Time');
                    showSnackbar(true);
                    return; // Stop form submission
                }
            }
            
            payload.pre_pickup_container_pickup_id = containerPickupAddress;
            payload.pre_pickup_container_drop_id = pickupAddress;
            payload.pre_pickup_container_pickup_time = containerPickupDate;
        }

        try {
            const url = operationsUrl + '/transport/add_update_bookings';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchBookingsData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }
    
    // CSV import-related functions
    // Define required columns for CSV import
    const requiredColumns = ['name', 'type_of_movement', 'container_type', 'container_size', 'pickup_address', 'drop_address', 'pickup_date', 'drop_date', 'tms_client_id', 'booking_type'];
    
    // Define alternative column names for flexibility in import
    const alternativeColumns = {
        'name': ['Name', 'name', 'NAME', 'Name', 'Client'],
        'type_of_movement': ['Type of Movement', 'type_of_movement', 'TYPE_OF_MOVEMENT', 'Movement Type'],
        'container_type': ['Container Type', 'container_type', 'CONTAINER_TYPE'],
        'container_size': ['Container Size', 'container_size', 'CONTAINER_SIZE'],
        'pickup_address': ['Pickup Address', 'pickup_address', 'PICKUP_ADDRESS'],
        'drop_address': ['Drop Address', 'drop_address', 'DROP_ADDRESS'],
        'pickup_date': ['Pickup Date', 'pickup_date', 'pickup_time', 'PICKUP_DATE'],
        'drop_date': ['Drop Date', 'drop_date', 'drop_time', 'DROP_DATE'],
        'tms_client_id': ['TMS Client ID', 'tms_client_id', 'TMS_CLIENT_ID'],
        'booking_type' : ['Booking Type', 'booking_type']
    };
    
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        // Use the required columns with example data
        const headers = requiredColumns;
        const exampleRow = ['Booking Name', 'Import', 'Isotainers', '20 Foot', 'Pickup Location Address', 'Drop Location Address', '2025-05-28 10:00:00', '2025-05-28 18:00:00', '1', 'ON'];
        const csvContent = headers.join(',') + '\n' + exampleRow.join(',');
        
        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Bookings_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    // Generate template data for CSV download
    const generateTemplateData = () => {
        // Create header row using the first alternative column name for each required column
        const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);
        
        // Create an empty row example
        const emptyRow = {};
        requiredColumns.forEach(col => {
            emptyRow[alternativeColumns[col] ? alternativeColumns[col][0] : col] = '';
        });
        
        return [headers.reduce((obj, header, index) => {
            obj[header] = '';
            return obj;
        }, {})];
    };
    
    // Template CSV headers for download
    const templateHeaders = requiredColumns.map(col => ({
        label: alternativeColumns[col] ? alternativeColumns[col][0] : col,
        key: alternativeColumns[col] ? alternativeColumns[col][0] : col
    }));
    
    // Handle CSV import button click
    const handleImportCSV = () => {
        // Trigger the hidden file input
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    
    // Handle the actual file selection
    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the shared function
                    const result = await processBookingImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchBookingsData();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported booking data using the shared processBulkImport function
    const processBookingImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_bookings';
        
        // Map function to convert CSV data to the expected API format
        const mapBookingData = (item) => {
            // Parse dates if provided
            
            let pickupDateString = null;
            let dropDateString = null;
            console.log('item', item);
            try {
                if (item.pickup_date || item['Pickup Date']) {
                    pickupDateString = item.pickup_date || item['Pickup Date'];
                    console.log('pickupDateString', pickupDateString);
                    // let pickupDateValue = new Date(pickupDateString).toISOString();
                    // console.log('pickupDateValue', pickupDateValue)
                }
                
                if (item.drop_date || item['Drop Date']) {
                     dropDateString = item.drop_date || item['Drop Date'];
                     console.log('dropDateString', dropDateString);
                    // dropDateValue = new Date(dropDateString).toISOString();
                }
            } catch (error) {
                console.error('Error parsing dates:', error);
            }
            
            // Create booking object from CSV data
            const bookingData = {
                city_id: cityFilter,
                // name: item.name || item['Name'] || '',
                container_movement_type: item.type_of_movement || item['Type of Movement'] || '',
                container_type: item.container_type || item['Container Type'] || '',
                container_size: item.container_size || item['Container Size'] || '',
                // pickup_address: item.pickup_address || item['Pickup Address'] || '',
                // drop_address: item.drop_address || item['Drop Address'] || '',
                pickup_time: pickupDateString,
                drop_time: dropDateString,
                tms_client_id: item.tms_client_id || item['TMS Client ID'] || '',
                booking_type: item.booking_type || item['Booking Type']
            };
            
            return bookingData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'bookings', mapBookingData);
    };

    const fetchTmsLocation = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_locations';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setLocationData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const handleRejectChange = (event) => {
        setRejectValue(event.target.value);
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Booking
            </Typography>

            <Grid2 container alignItems="center" style={{ marginTop: '1%', marginBottom: '1%', alignItems:'center' }}>
                <Grid2 item>
                    <Label></Label>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'40px', marginTop:'20px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'3%'}}>
                    <Label>Booking Status:</Label><br/>
                    <Select
                        value={bookingStatusFilter} 
                        fullWidth
                        onChange={(e) => setBookingStatusFilter( e.target.value)}
                        style={{ height: '40px', borderRadius: '8px', backgroundColor: '#FFFFFF', width:'180px', marginTop:'4px'}}>
                            <MenuItem value="-1">All</MenuItem>
                            {Object.entries(constants.tmsBookingStatus).map(([id, label]) => (
                                <MenuItem key={id} value={id}>
                                    {label}
                                </MenuItem>
                            ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'3%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDateFilter}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'3%'}}>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => setEndDateFilter(newValue)}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginTop:'2%', marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddbooking}
                        style={{
                            width: '185px',
                            height: '46px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Booking
                    </Button>
                </Grid2>
            </Grid2>


            <div className="button-container" style={{marginTop: "0px",marginBottom: "2%",display: "flex",alignItems: "flex-end",justifyContent: "space-between"}}>
                <Grid2 sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                    
                    {/* Export CSV Button */}
                    <Button
                        variant="contained"
                        style={{
                        width: "120px",
                        height: "44px",
                        backgroundColor: "#36C68F",
                        textTransform: "none",
                        borderRadius: "8px",
                        marginLeft: "8px"
                        }}
                    >
                        <CSVLink 
                        data={allData}
                        filename={"Booking Data.csv"}
                        style={{ textDecoration: "none" }}
                        >
                        <Typography sx={{ color: "#fff" }}>Export CSV</Typography>
                        </CSVLink>
                    </Button>
                    
                    {/* Hidden file input for CSV import */}
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                    />
                    
                    {/* Import CSV Button */}
                    <div style={{ position: 'relative' }}>
                        <Button
                            variant="contained"
                            onClick={handleImportCSV}
                            style={{
                            width: "120px",
                            height: "44px",
                            backgroundColor: "#36C68F",
                            textTransform: "none",
                            borderRadius: "8px",
                            marginLeft: "8px"
                            }}
                        >
                            <Typography sx={{ color: "#fff" }}>Import CSV</Typography>
                        </Button>

                        <Button
                            variant="contained"
                            onClick={downloadCSVTemplate}
                            style={{
                            width: "auto",
                            height: "44px",
                            backgroundColor: "#36C68F",
                            textTransform: "none",
                            borderRadius: "8px",
                            marginLeft: "24px"
                            }}
                        >
                            <Typography sx={{ color: "#fff" }}>Download Sample CSV</Typography>
                        </Button>
                    </div>
                    

                </Grid2>        
            </div>


            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '24px', marginTop: '8px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Booking' : 'Add Booking'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Client<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.clientId && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Client is required</Typography>}
                                        <Select sx={{marginTop:'2%'}}
                                            value={clientId} 
                                            fullWidth
                                            error={formErrors.clientId}
                                            onChange={(e) => {
                                                setClientId(e.target.value);
                                                setFormErrors({...formErrors, clientId: !e.target.value});
                                            }}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            {clientData && clientData.map((client) => (
                                                <MenuItem key={client.tms_client_id} value={client.tms_client_id}>
                                                    {client.tms_client_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Type of Movement<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.movementType && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Type of Movement is required</Typography>}
                                        <Select 
                                            sx={{
                                                marginTop:'2%',
                                                height: '50px',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius:'12px'
                                            }}
                                            value={movementType} 
                                            fullWidth
                                            error={formErrors.movementType}
                                            onChange={(e) => {
                                                setMovementType(e.target.value);
                                                setFormErrors({...formErrors, movementType: !e.target.value});
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Movement Type</Typography>
                                            </MenuItem>
                                            {bookingConstants?.booking_fields?.type_of_movement?.map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                style={{ padding: '20px 30px', maxWidth: '800px', margin: '8px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>

                                <Typography style={{ marginBottom: '24px', marginTop: '8px', fontWeight: '500', fontSize: '20px' }}>
                                    Container Details
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Label>Container Type<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.containerType && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Type is required</Typography>}
                                        <Select
                                            sx={{
                                                marginTop:'2%',
                                                height: '50px',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius:'12px'
                                            }}
                                            value={containerType}
                                            fullWidth
                                            error={formErrors.containerType}
                                            onChange={(e) => {
                                                setContainerType(e.target.value);
                                                setFormErrors({...formErrors, containerType: !e.target.value});
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Container Type</Typography>
                                            </MenuItem>
                                            {bookingConstants?.booking_fields?.container_type?.map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Container Size<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.containerSize && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Size is required</Typography>}
                                        <Select
                                            sx={{
                                                marginTop:'2%',
                                                height: '50px',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius:'12px'
                                            }}
                                            value={containerSize}
                                            fullWidth
                                            error={formErrors.containerSize}
                                            onChange={(e) => {
                                                setContainerSize(e.target.value);
                                                setFormErrors({...formErrors, containerSize: !e.target.value});
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Container Size</Typography>
                                            </MenuItem>
                                            {bookingConstants?.booking_fields?.container_size?.map((size) => (
                                                <MenuItem key={size} value={size}>
                                                    {size.charAt(0).toUpperCase() + size.slice(1)}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                                {/* Container Section */}
                                {containers.map((container, index) => (
                                    <Grid container sx={{border:'1px solid #D1D5DB', marginTop:'12px', padding: '12px', borderRadius:'12px'}} key={index}>
                                        <Grid sx={{backgroundColor:'#F9F9F9', padding:'8px', marginBottom:'8px', width:'100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                            <Typography sx={{color:'#000'}}>Container #{index + 1}</Typography>
                                            {index > 0 && (
                                                <IconButton onClick={() => handleRemoveContainer(index)} size="small" sx={{ color: '#EF4444' }}>
                                                    <CloseIcon />
                                                </IconButton>
                                            )}
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={12}>
                                            <Label>Container Number<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.containerDetails[index]?.container_no && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Number is required</Typography>}
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Container Number" fullWidth variant="outlined" type="text" 
                                                value={container.container_no}
                                                error={formErrors.containerDetails[index]?.container_no}
                                                onChange={(e) => {
                                                    handleContainerChange(index, 'container_no', e.target.value);
                                                    
                                                    // Update validation state for this specific container field
                                                    const updatedContainerErrors = [...formErrors.containerDetails];
                                                    updatedContainerErrors[index] = {
                                                        ...updatedContainerErrors[index],
                                                        container_no: !e.target.value.trim()
                                                    };
                                                    setFormErrors({...formErrors, containerDetails: updatedContainerErrors});
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                            <Label>Container Condition<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.containerDetails[index]?.container_condition && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Condition is required</Typography>}
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Container Condition" fullWidth variant="outlined" type="text" 
                                                value={container.container_condition}
                                                error={formErrors.containerDetails[index]?.container_condition}
                                                onChange={(e) => {
                                                    handleContainerChange(index, 'container_condition', e.target.value);
                                                    
                                                    // Update validation state for this specific container field
                                                    const updatedContainerErrors = [...formErrors.containerDetails];
                                                    updatedContainerErrors[index] = {
                                                        ...updatedContainerErrors[index],
                                                        container_condition: !e.target.value.trim()
                                                    };
                                                    setFormErrors({...formErrors, containerDetails: updatedContainerErrors});
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                            <Label>Container Size Value<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.containerDetails[index]?.container_size_value && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Size Value is required</Typography>}
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Container Size Value" fullWidth variant="outlined" type="number" 
                                                value={container.container_size_value}
                                                error={formErrors.containerDetails[index]?.container_size_value}
                                                onChange={(e) => {
                                                    handleContainerChange(index, 'container_size_value', e.target.value);
                                                    
                                                    // Update validation state for this specific container field
                                                    const updatedContainerErrors = [...formErrors.containerDetails];
                                                    updatedContainerErrors[index] = {
                                                        ...updatedContainerErrors[index],
                                                        container_size_value: !e.target.value
                                                    };
                                                    setFormErrors({...formErrors, containerDetails: updatedContainerErrors});
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))}
                                
                                {/* Add Container Button */}
                                <Grid container justifyContent="center" sx={{marginTop: '16px'}}>
                                    <Button 
                                        variant="outlined" 
                                        color="primary" 
                                        onClick={handleAddContainer}
                                        startIcon={<AddIcon />}
                                        sx={{
                                            height: "50px", 
                                            borderRadius: "8px", 
                                            color: "#0065FF",
                                            borderColor: "#0065FF",
                                            textTransform: "none"
                                        }}
                                    >
                                        Add Container
                                    </Button>
                                </Grid>
                            </Paper>

                            <Paper
                                style={{ padding: '20px 30px', maxWidth: '800px', margin: '8px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>

                                <Typography style={{ marginBottom: '24px', marginTop: '8px', fontWeight: '500', fontSize:'20px' }}>
                                    Schedule Details
                                </Typography>

                                <Grid2 sx={{ marginBottom: '16px' }}>
                                    <FormControl fullWidth>
                                        <RadioGroup 
                                            row
                                            defaultValue=""
                                            name="controlled-radio-buttons-group"
                                            value={rejectValue}
                                            onChange={handleRejectChange}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: '24px'
                                            }}
                                        >
                                            <FormControlLabel 
                                                value="1" 
                                                control={<Radio />} 
                                                label="On"
                                                sx={{ margin: 0 }}
                                            />
                                            <FormControlLabel 
                                                value="2" 
                                                control={<Radio />} 
                                                label="On or Before"
                                                sx={{ marginLeft: '8%' }}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid2>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Label>Enter Location<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.pickupAddress && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Pickup Location is required</Typography>}
                                        <Select
                                            sx={{
                                                marginTop: '2%',
                                                height: '50px',
                                                borderRadius:'12px',
                                                backgroundColor: '#FFFFFF',
                                                '& .MuiSelect-select': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }
                                            }}
                                            fullWidth
                                            value={pickupAddress}
                                            error={formErrors.pickupAddress}
                                            onChange={(e) => {
                                                setPickupAddress(e.target.value);
                                                setFormErrors({...formErrors, pickupAddress: !e.target.value});
                                            }}
                                            displayEmpty
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <img src={pickupMarker} alt="pickup marker" />
                                                </InputAdornment>
                                            }
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Pickup Location</Typography>
                                            </MenuItem>
                                            {locationData.map((location) => (
                                                <MenuItem key={location.location_id} value={location.location_id}>
                                                    {location.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {formErrors.dropAddress && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Drop Location is required</Typography>}
                                        <Select
                                            sx={{
                                                marginTop: '2%',
                                                height: '50px',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius:'12px',
                                                '& .MuiSelect-select': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }
                                            }}
                                            fullWidth
                                            value={dropAddress}
                                            error={formErrors.dropAddress}
                                            onChange={(e) => {
                                                setDropAddress(e.target.value);
                                                setFormErrors({...formErrors, dropAddress: !e.target.value});
                                            }}
                                            displayEmpty
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <img src={dropMarker} alt="drop marker" />
                                                </InputAdornment>
                                            }
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Drop Location</Typography>
                                            </MenuItem>
                                            {locationData.map((location) => (
                                                <MenuItem key={location.location_id} value={location.location_id}>
                                                    {location.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Distance (in km)<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.distance && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Distance is required</Typography>}
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Distance (in km)" fullWidth variant="outlined" type="number" 
                                            value={distance}
                                            error={formErrors.distance}
                                            onChange={(e) => {
                                                setDistance(e.target.value);
                                                setFormErrors({...formErrors, distance: !e.target.value});
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'12px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Pickup Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.pickupDate && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Pickup Date & Time is required</Typography>}
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer
                                                components={['DateTimePicker']}
                                                sx={{
                                                    marginTop: '8px',
                                                    '& .MuiStack-root': {
                                                        padding: 0
                                                    }
                                                }}
                                            >
                                                <DateTimePicker
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#FFFFFF'
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '16px',
                                                            padding: '8px 14px'
                                                        }
                                                    }}
                                                    value={pickupDate}
                                                    onChange={(newValue) => {
                                                        setPickupDate(newValue);
                                                        setFormErrors({...formErrors, pickupDate: !newValue});
                                                    }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    ampm={false}
                                                    slotProps={{
                                                        textField: {
                                                            error: formErrors.pickupDate,
                                                            fullWidth: true,
                                                            placeholder: 'Select date and time'
                                                        }
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                        
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Drop Date<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.dropDate && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Drop Date is required</Typography>}
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer
                                                components={['DateTimePicker']}
                                                sx={{
                                                    marginTop: '8px',
                                                    '& .MuiStack-root': {
                                                        padding: 0
                                                    }
                                                }}
                                            >
                                                <DateTimePicker
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#FFFFFF'
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '16px',
                                                            padding: '8px 14px'
                                                        }
                                                    }}
                                                    value={dropDate}
                                                    onChange={(newValue) => {
                                                        if (newValue && dayjs(newValue).isBefore(pickupDate)) {
                                                            setMessage("Drop date & time cannot be earlier than pickup date & time");
                                                            showSnackbar(true);
                                                        } else {
                                                            setDropDate(newValue);
                                                            setFormErrors({...formErrors, dropDate: !newValue});
                                                        }
                                                    }}
                                                    format="YYYY-MM-DD HH:mm"
                                                    ampm={false}
                                                    slotProps={{
                                                        textField: {
                                                            error: formErrors.dropDate,
                                                            fullWidth: true,
                                                            placeholder: 'Select date and time'
                                                        }
                                                    }}
                                                    minDateTime={pickupDate}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                style={{ padding: '20px 30px', maxWidth: '800px', margin: '8px auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>

                                <Typography style={{ marginBottom: '18px', marginTop: '8px', fontWeight: '500', fontSize:'20px' }}>
                                    Pre-pickup Container
                                </Typography>

                                <Grid2 sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'4px', marginBottom:'12px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                                    <Typography>Pre-pickup Container</Typography>
                                    <Switch
                                        checked={prePickupEnabled}
                                        onChange={(e) => setPrePickupEnabled(e.target.checked)}
                                        color="primary"
                                    />
                                </Grid2>

                                {prePickupEnabled && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <Label>Container Location<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.containerPickupAddress && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Location is required</Typography>}
                                            <Grid2 sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'8px', marginBottom:'4px', marginTop:'4px'}}>
                                                <Select
                                                    sx={{
                                                        marginTop: '2%',
                                                        height: '50px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius:'12px',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }
                                                    }}
                                                    fullWidth
                                                    value={containerPickupAddress}
                                                    error={formErrors.containerPickupAddress}
                                                    onChange={(e) => {
                                                        setContainerPickupAddress(e.target.value);
                                                        setFormErrors({...formErrors, containerPickupAddress: !e.target.value});
                                                    }}
                                                    displayEmpty
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <img src={pickupMarker} alt="pickup marker" />
                                                        </InputAdornment>
                                                    }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <Typography sx={{ color: '#666' }}>Select Pickup Location</Typography>
                                                    </MenuItem>
                                                    {locationData.map((location) => (
                                                        <MenuItem key={location.location_id} value={location.location_id}>
                                                            {location.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <Select
                                                    sx={{
                                                        marginTop: '2%',
                                                        height: '50px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius:'12px',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }
                                                    }}
                                                    fullWidth
                                                    value={pickupAddress}
                                                    onChange={(e) => setPickupAddress(e.target.value)}
                                                    displayEmpty
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <img src={dropMarker} alt="drop marker" />
                                                        </InputAdornment>
                                                    }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <Typography sx={{ color: '#666' }}>Select Drop Location</Typography>
                                                    </MenuItem>
                                                    {locationData.map((location) => (
                                                        <MenuItem key={location.location_id} value={location.location_id}>
                                                            {location.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid2>
                                            
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Label>Pickup Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                            {formErrors.containerPickupDate && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Container Pickup Date & Time is required</Typography>}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={['DateTimePicker']}
                                                    sx={{
                                                        marginTop: '8px',
                                                        '& .MuiStack-root': {
                                                            padding: 0
                                                        }
                                                    }}
                                                >
                                                    <DateTimePicker
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': {
                                                                height: '52px',
                                                                borderRadius: '12px',
                                                                backgroundColor: '#FFFFFF'
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                                padding: '8px 14px'
                                                            }
                                                        }}
                                                        value={containerPickupDate}
                                                        onChange={(newValue) => {
                                                            // Update validation state
                                                            setFormErrors({...formErrors, containerPickupDate: !newValue});
                                                            
                                                            // Validate container pickup date is less than pickup date
                                                            if (newValue && pickupDate) {
                                                                const containerPickupDateTime = new Date(newValue);
                                                                const pickupDateTime = new Date(pickupDate);
                                                                
                                                                if (containerPickupDateTime >= pickupDateTime) {
                                                                    setMessage('Container Pickup Date & Time should be less than the Pickup Date & Time');
                                                                    showSnackbar(true);
                                                                    // Still set the value to allow user to see their selection
                                                                    setContainerPickupDate(newValue);
                                                                    return;
                                                                }
                                                            }
                                                            setContainerPickupDate(newValue);
                                                        }}
                                                        format="YYYY-MM-DD HH:mm"
                                                        ampm={false}
                                                        slotProps={{
                                                            textField: {
                                                                error: formErrors.containerPickupDate,
                                                                fullWidth: true,
                                                                placeholder: 'Select date and time'
                                                            }
                                                        }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            
                                        </Grid>
                                    </Grid>
                                )}
                            </Paper>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'10%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    sx={{width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                    {openEditModal ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{maxHeight:'70vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Booking ID</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'booking_id'}
                                    direction={orderBy === 'booking_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('booking_id')}
                                >
                                    Booking ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'tms_client_name'} direction={orderBy === 'tms_client_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_client_name')}>
                                Client
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'container_movement_type'} direction={orderBy === 'container_movement_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_movement_type')}>
                                Type of Movement
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'container_size'} direction={orderBy === 'container_size' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_size')}>
                                Size
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                            <TableSortLabel active={orderBy === 'pickup_address'} direction={orderBy === 'pickup_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_address')}>
                                Source
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'drop_address'} direction={orderBy === 'drop_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_address')}>
                                Destination
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Request Delivery</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'booking_status'} direction={orderBy === 'booking_status' ? order : 'asc'}
                                    onClick={() => handleRequestSort('booking_status')}>
                                Booking Status
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Plate No</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                            <TableSortLabel active={orderBy === 'pickup_time'} direction={orderBy === 'pickup_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_time')}>
                                Pickup Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                            <TableSortLabel active={orderBy === 'drop_time'} direction={orderBy === 'drop_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_time')}>
                                Drop Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                            <TableSortLabel active={orderBy === 'container_details'} direction={orderBy === 'container_details' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_details')}>
                                Container Details
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Container Condition</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {

                            return(
                                <TableRow key={row.chasis_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_movement_type}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_size}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_address}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.chasis_type}</Typography></TableCell> */}
                                    <TableCell align="center">
                                        <Typography 
                                            sx={{ 
                                                width: 'auto', 
                                                minWidth: '100px',
                                                color: row?.booking_status === 5 ? '#C71F1F' :
                                                       row?.booking_status === 6 ? '#e37756' :
                                                       row?.booking_status === 4 ? '#0DBA78' :
                                                       row?.booking_status === 3 ? '#2196F3' :
                                                       row?.booking_status === 2 ? '#9C27B0' :
                                                       '#F5BB19'
                                            }}
                                        >
                                            {bookingStatusMap[row?.booking_status] || row?.booking_status}
                                        </Typography>
                                    </TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.address}</Typography></TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {row.pickup_time ? dayjs(row.pickup_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {row.drop_time ? dayjs(row.drop_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center">
                                        {row.container_details && typeof row.container_details === 'object' ? (
                                            <Box sx={{ minWidth: '200px', maxWidth: '250px', padding: '8px', margin: '0 auto' }}>
                                                {Object.keys(row.container_details).map((key, index) => {
                                                    const container = row.container_details[key];
                                                    return (
                                                        <Box 
                                                            key={index} 
                                                            sx={{ 
                                                                mb: index < Object.keys(row.container_details).length - 1 ? 1.5 : 0,
                                                                pb: index < Object.keys(row.container_details).length - 1 ? 1 : 0,
                                                                borderBottom: index < Object.keys(row.container_details).length - 1 ? '1px dashed #e0e0e0' : 'none'
                                                            }}
                                                        >
                                                            <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Number :</span>
                                                                <span style={{ flex: 1, textAlign: 'left' }}>{container.container_no || 'N/A'}</span>
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Condition :</span>
                                                                <span style={{ flex: 1, textAlign: 'left' }}>{container.container_condition || 'N/A'}</span>
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <span style={{ fontWeight: 600, color: '#555', width: '110px' }}>Size :</span>
                                                                <span style={{ flex: 1, textAlign: 'left' }}>{container.container_size_value || 'N/A'}</span>
                                                            </Typography>
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                        ) : (
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                {typeof row.container_details === 'string' ? row.container_details : 'No container details'}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_condition}</Typography></TableCell> */}
                                    <TableCell align="center" sx={{ height: '100%', padding: '16px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                            {(row.booking_status==1) && (
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleOpenEditBooking(row)}
                                                    sx={{
                                                        backgroundColor: '#EFFBF7',
                                                        color: '#0DBA78',
                                                        border: '1px solid #0DBA78',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '40px',
                                                        width: '90px',
                                                        height: '36px',
                                                        boxShadow: 'none',
                                                        '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                                        '&:active': { backgroundColor: '#0DBA78', color: 'white' }
                                                    }}
                                                >
                                                    <Typography>Edit</Typography>
                                                </Button>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={showTemplateButton ? 6000 : 2000} 
                onClose={handleSnackbarClose} 
                message={message}
                action={showTemplateButton && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <CSVLink
                            data={generateTemplateData()}
                            headers={templateHeaders}
                            filename="booking_template.csv"
                            className="download-template-btn"
                            style={{
                                textDecoration: 'none',
                                marginRight: '8px'
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: '#3B82F6',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#2563EB',
                                    },
                                    textTransform: 'none',
                                    fontSize: '12px',
                                    minWidth: 'auto',
                                    borderRadius: '4px',
                                    padding: '4px 8px'
                                }}
                            >
                                Download Template
                            </Button>
                        </CSVLink> */}
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleSnackbarClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                )}
            />
            

        </div>
    )
}

export default TmsBooking;